import React, { useMemo, useState } from 'react'
import { Container, Row, Col } from 'reactstrap'

import CommonSection from '../components/UI/CommonSection'
import Helmet from '../components/Helmet/Helmet'
import ProductsList from '../components/UI/ProductsList'
import products from '../assets/data/products'
import '../styles/shop.css'

const Shop = () => {
  const [category, setCategory] = useState('all')
  const [sort, setSort] = useState('featured')
  const [search, setSearch] = useState('')

  const productsData = useMemo(() => {
    const filtered = products.filter((item) =>
      (category === 'all' || item.category === category) &&
      item.productName.toLowerCase().includes(search.trim().toLowerCase())
    )
    return [...filtered].sort((a, b) => {
      if (sort === 'low') return a.price - b.price
      if (sort === 'high') return b.price - a.price
      if (sort === 'rating') return b.avgRating - a.avgRating
      return 0
    })
  }, [category, search, sort])

  return (
    <Helmet title='Shop'>
      <CommonSection eyebrow='The collection' title='Find your next upgrade.' subtitle='Thoughtfully selected tech for work, play and everything between.' />

      <section className='shop__section'>
        <Container>
          <div className='shop__toolbar'>
            <div className='search__box'>
              <i className='ri-search-line'></i>
              <input type='search' aria-label='Search products' placeholder='Search phones, laptops, gaming…' value={search} onChange={(e) => setSearch(e.target.value)} />
            </div>
            <div className='filter__group'>
              <label><span>Category</span><select value={category} onChange={(e) => setCategory(e.target.value)}><option value='all'>All products</option><option value='console'>Gaming</option><option value='mobile'>Phones</option><option value='computer'>Computers</option><option value='watch'>Watches</option><option value='wireless'>Audio</option></select></label>
              <label><span>Sort</span><select value={sort} onChange={(e) => setSort(e.target.value)}><option value='featured'>Featured</option><option value='low'>Price: low to high</option><option value='high'>Price: high to low</option><option value='rating'>Top rated</option></select></label>
            </div>
          </div>
          <div className='shop__results'><span>{productsData.length} products</span><span>All prices shown in PKR</span></div>
          <Row>
            {productsData.length === 0 ? (
              <Col><div className='empty__state'><i className='ri-search-eye-line'></i><h2>No matches yet</h2><p>Try a different search or reset the category filter.</p><button className='buy__btn' onClick={() => { setSearch(''); setCategory('all') }}>Reset filters</button></div></Col>
            ) : <ProductsList data={productsData} />}
          </Row>
        </Container>
      </section>
    </Helmet>
  )
}

export default Shop
